import { Box, Container, Typography, Button, Paper } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";
import MKBox from "components/MKBox";
import { Helmet } from "react-helmet-async";

//routes
import routes from "routes";
const EscalasSalariales = [
  {
    title: "Octubre - Noviembre 2026",
    direccion: "https://drive.google.com/file/d/1KKj5nSZuzEDm4teNVaVAD-MgVRazdfb3/view?usp=sharing",
  },
  {
    title: "Septiembre 2026",
    direccion: "https://drive.google.com/file/d/14w9lI6BrOs8vdNQEQV98OCmAJG5IjKTR/view?usp=sharing",
  },
  {
    title: "Agosto 2026",
    direccion: "https://drive.google.com/file/d/1yBNdtmZYjEDlJSNvA1Rpxh8BRjDtyg-I/view?usp=sharing",
  },
  {
    title: "Mayo - Septiembre 2026",
    direccion: "https://drive.google.com/file/d/1hmZD4ub1TRSfCOPxjw1jS087OLiL1eZt/view?usp=sharing",
  },
  {
    title: "Enero - Abril 2026",
    direccion:
      "https://drive.google.com/file/d/1AyOvgZlcKf26DLiQ404QT30YQL-P0EV7/view?usp=drive_link",
  },
  {
    title: "Agosto - Diciembre 2025",
    direccion:
      "https://drive.google.com/file/d/13EOmaEtYrrf_vy1PBBxEvIIcsJAes-ff/view?usp=drive_link",
  },
  {
    title: "Mayo - Julio 2025",
    direccion: "https://drive.google.com/file/d/1sjfHYNQdOcTt_6evEJAp6i2X1rJ-KqMH/view?usp=sharing",
  },
  {
    title: "Febrero - Mayo 2025",
    direccion: "https://drive.google.com/file/d/15o2hErvBR05PdcgVVCsT7pMUMXD-OCBx/view?usp=sharing",
  },
  {
    title: "Octubre 2024 - Enero 2025",
    direccion: "https://drive.google.com/file/d/1xRPHgnlZMv0XxEprYca2qs_WYRDvqG9F/view?usp=sharing",
  },
  {
    title: "Abril - Agosto 2024",
    direccion: "https://drive.google.com/file/d/1tscyaGpBtaPb-85jCUq5nJ3QbpnWp7fB/view?usp=sharing",
  },
  {
    title: "Enero - Marzo 2024",
    direccion:
      "https://drive.google.com/file/d/1RE3O_upozx7aZMMpeCU4JWuqspDL1gk3/view?usp=drive_link",
  },
  {
    title: "Mayo 2023 - Enero 2024",
    direccion:
      "https://drive.google.com/file/d/1AzHwQSd2c1RZsiJP4ZXRTlho-rVTZSpR/view?usp=drive_link",
  },
  {
    title: "Septiembre 2022 - Abril 2023",
    direccion: "https://drive.google.com/file/d/1dWWXbgjjBU5qMY36fFczs9p3VWS3w8A3/view?usp=sharing",
  },
];

export default function EscalasSalarialesPage() {
  return (
    <>
      <Helmet>
        <title>Escalas Salariales y CCT 478/06 | Sindicato Panaderos San Juan</title>

        <meta
          name="description"
          content="Consulte las escalas salariales actualizadas 2026, el Convenio Colectivo de Trabajo 478/06 y las actas acuerdo del Sindicato de Panaderos de San Juan."
        />

        <meta
          name="keywords"
          content="escala salarial panaderos 2026, CCT 478/06 panaderos, sueldo panadero san juan, acta acuerdo panaderos, paritarias panaderos 2026, escala salarial vigente"
        />

        {/* Open Graph para uso profesional */}
        <meta
          property="og:title"
          content="Escalas Salariales y Normativa Laboral - Panaderos San Juan"
        />
        <meta
          property="og:description"
          content="Descarga directa de escalas salariales vigentes, CCT 478/06 y actas acuerdo para el sector panadero."
        />
        <meta property="og:type" content="article" />

        <link
          rel="canonical"
          href="http://www.sindicatopanaderossanjuan.com.ar/escalas-salariales"
        />
      </Helmet>
      <DefaultNavbar routes={routes} />
      <Container maxWidth="md" sx={{ py: 6, paddingTop: "6rem" }}>
        {/* TÍTULO */}
        <Typography variant="h3" align="center" fontWeight="bold" gutterBottom>
          ESCALAS SALARIALES
        </Typography>

        {/* LÍNEA */}
        <Box
          sx={{
            width: "80%",
            height: "3px",
            backgroundColor: "#1976d2",
            mx: "auto",
            mb: 4,
          }}
        />

        {/* LISTA */}
        <Box display="flex" flexDirection="column" gap={2}>
          {EscalasSalariales.map((item, index) => (
            <Paper
              key={index}
              elevation={1}
              sx={{
                p: 3,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: 2,
              }}
            >
              <Typography variant="h6">{item.title}</Typography>

              <Button
                variant="contained"
                endIcon={<DownloadIcon />}
                onClick={() => window.open(item.direccion, "_blank")}
                sx={{
                  textTransform: "none",
                  fontWeight: "bold",
                  color: "#FFFFFF",
                }}
              >
                DESCARGAR
              </Button>
            </Paper>
          ))}
        </Box>
        <Typography
          variant="h3"
          align="center"
          fontWeight="bold"
          gutterBottom
          sx={{
            paddingTop: "5rem",
          }}
        >
          CONVENIO COLECTIVO DE TRABAJO
        </Typography>

        {/* LÍNEA */}
        <Box
          sx={{
            width: "80%",
            height: "3px",
            backgroundColor: "#1976d2",
            mx: "auto",
            mb: 4,
          }}
        />
        <Paper
          elevation={1}
          sx={{
            p: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 2,
          }}
        >
          <Typography variant="h6">Convenio Colectivo de Trabajo N°478-06</Typography>

          <Button
            variant="contained"
            endIcon={<DownloadIcon />}
            onClick={() =>
              window.open(
                "https://drive.google.com/file/d/1X2940Hv0BHp0oWleLJbzOR_GPSLc4vBP/view?usp=sharing",
                "_blank"
              )
            }
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#FFFFFF",
            }}
          >
            DESCARGAR
          </Button>
        </Paper>
        <Typography
          variant="h3"
          align="center"
          fontWeight="bold"
          gutterBottom
          sx={{
            paddingTop: "5rem",
          }}
        >
          ACTA ACUERDO
        </Typography>

        {/* LÍNEA */}
        <Box
          sx={{
            width: "80%",
            height: "3px",
            backgroundColor: "#1976d2",
            mx: "auto",
            mb: 4,
          }}
        />
        <Paper
          elevation={1}
          sx={{
            p: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 2,
          }}
        >
          <Typography variant="h6">Acta Acuerdo Sindicato Panaderos y Pasteleros</Typography>

          <Button
            variant="contained"
            endIcon={<DownloadIcon />}
            onClick={() =>
              window.open(
                "https://drive.google.com/file/d/1ifaSCOsUazaR6WNX2z8CGyLOvDptn8U3/view?usp=sharing",

                "_blank"
              )
            }
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#FFFFFF",
            }}
          >
            DESCARGAR
          </Button>
        </Paper>
        <Typography
          variant="h3"
          align="center"
          fontWeight="bold"
          gutterBottom
          sx={{
            paddingTop: "5rem",
          }}
        >
          ACTA ACUERDO AGOSTO - NOVIEMBRE 2026
        </Typography>

        {/* LÍNEA */}
        <Box
          sx={{
            width: "80%",
            height: "3px",
            backgroundColor: "#1976d2",
            mx: "auto",
            mb: 4,
          }}
        />
        <Paper
          elevation={1}
          sx={{
            p: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: 2,
          }}
        >
          <Typography variant="h6">
            Acta Acuerdo Sindicato Panaderos y Pasteleros Agosto - Noviembre 2026
          </Typography>

          <Button
            variant="contained"
            endIcon={<DownloadIcon />}
            onClick={() =>
              window.open(
                "https://drive.google.com/file/d/1nZhRi0nQvFrXQ5gsrQusdvwgBhma0V6y/view?usp=sharing",
                "_blank"
              )
            }
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              color: "#FFFFFF",
            }}
          >
            DESCARGAR
          </Button>
        </Paper>
      </Container>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}
